<app-legal-person-validated-form [formGroupInput]="legalPersonForm" />
